import comps from './comps'
import pages from './pages'
import other from './other'

export default {
  ...other,
  comps,
  pages,
}
